import { BaseDataService } from "../../../services/base/BaseDataService";
import { ProjectDocFolderStatus } from "../models/ProjectDocFolderStatus";
import { ProjectDocFolderStatusQuery } from "../models/ProjectDocFolderStatusQuery";

export class ProjectDocFolderStatusService extends BaseDataService<
  ProjectDocFolderStatus,
  ProjectDocFolderStatusQuery
> {
  protected prefixUrl: string = `ProjectDocFolderStatuses`;
}
